import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { BotsService } from '@core/services/bots.service';
import { EntityCtrlDirective } from '@shared/directives/table-ctrl.directive';
import { Bot } from '@shared/models';
import { Observable, switchMap } from 'rxjs';
import {
  MatCard,
  MatCardHeader,
  MatCardTitle,
  MatCardContent,
  MatCardFooter,
  MatCardActions,
} from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { TableBotsComponent } from '../table-bots/table-bots.component';
import { TablePaginatorComponent } from '../table-paginator/table-paginator.component';

@Component({
  selector: 'app-table-bots-ctrl',
  templateUrl: './table-bots-ctrl.component.html',
  styleUrl: './table-bots-ctrl.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatDivider,
    MatCardContent,
    TableBotsComponent,
    MatCardFooter,
    MatCardActions,
    TablePaginatorComponent,
  ],
})
export class TableBotsCtrlComponent
  extends EntityCtrlDirective<Bot>
  implements OnInit
{
  private readonly botsService = inject(BotsService);

  override entity$: Observable<{
    data: Bot[];
    hasNextPage: boolean;
    length: number;
    page: number;
  }> = this.pageNumber.pipe(
    switchMap((pageNumber) =>
      this.botsService.getAll({ page: pageNumber, limit: 20 })
    )
  );
}
